import { createContext, useContext } from 'react';
import {
  AppUIContextValue,
  AppUIHeaderAlertParams,
} from './AppUIProvider.types';

export const AppUIContext = createContext<AppUIContextValue>({
  alertNotification: {
    error: (text: string) => {
      alert(text);
    },
    info: (text: string) => {
      alert(text);
    },
    success: (text: string) => {
      alert(text);
    },
    warning: (text: string) => {
      alert(text);
    },
  },
  headerAlert: {
    show: (params: AppUIHeaderAlertParams) => alert(params.title),
    hide: () => {},
  },
  isMobile: false,
  isXs: false,
  isLoading: false,
  setIsLoading: () => {},
  statusBar: undefined,
});

AppUIContext.displayName = 'AppUIContext';

export function useAppUI() {
  const context = useContext(AppUIContext);

  if (context === undefined) {
    throw new Error('useAppUI must be used within an AppUIProvider');
  }
  return context;
}
